<template>
  <div key="inbox" class="inbox">
    <div class="inbox__wrapper">
      <div class="inbox__header mt mb2">
        <h1 
          :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
          class="h1 group__title m0">{{ heading[stage] }}</h1>
          <!-- <module-button button="primary" class="m0" @click.native="newMessage">New message</module-button> -->
      </div>

      <div class="inbox-grid inbox-grid__heading mb">
        <p 
          v-for="(heading, key) in inboxHeadings" 
          :key="key" 
          :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
          class="p small fw-bold c-accent">{{ heading }}</p>
      </div>
      <div
        class="inbox-grid cp"
        v-for="(message, key) in stage === 'inbox' ? getInbox : getOutbox"
        :key="key"
        @click="openMessage(message)"
      >
        <div
          v-for="(column, key) in inboxColumns"
          :key="key"
          :class="['inbox-grid__column', `inbox-grid__column--${column}`]">
          <p :class="['p', {'fw-bold' : message.unread_status && stage === 'inbox'} ]"> {{ message[column] }} </p>
        </div>
      </div>

      <div class="pagination mt">
        <span class="pagination__prev c-accent fw-bold cp" v-if="getPrevious || getNext === `page=3`" @click="getPaginated('previous')"> <module-icon class="mt-tiny" icon="arrow-prev" />Newer</span>
        <span class="pagination__next c-accent fw-bold cp" v-if="getNext" @click="getPaginated('next')">Older<module-icon class="mt-tiny ml-tiny" icon="arrow-next" /></span>

      </div>


      <p v-if="stage === `inbox` ? getInbox && getInbox.length === 0 : getOutbox && getOutbox.length === 0 ">You have no {{ stage === `inbox` ? `received` : `sent` }} messages</p>
    </div>
  </div>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

// Modules
import ModuleIcon from 'components/Icon.vue';


export default {
  name: 'module-inbox',

  // Components
  components: {
    ModuleIcon,
  },

  // Data
  data() {
    return {
      mdLive: JSON.parse(localStorage.getItem('updateUser')),
      stage: this.$route.params.id,
      heading: {
        inbox: 'Received Messages',
        outbox: 'Sent Messages',
      },
      loading: false,
      inboxHeadings: ['From', 'Subject', this.$route.params.id === 'inbox' ? 'Received' : 'Sent'],
      inboxColumns: ['from', 'subject', 'cleanDate'],
    };
  },

  computed: {
    ...mapGetters('auth', [
      'isAuthenticated',
    ]),
    ...mapGetters('messaging', ['getInbox', 'getOutbox', 'getAllContacts', 'getAllMessages', 'getUnreadCount', 'getPrevious', 'getNext']),
    ...mapGetters('app', ['org']),

    messagesPayload() {
      return {
        direction: null,
        filter: this.stage === 'inbox' ? 'received' : 'sent',
      };
    },
  },

  methods: {
    ...mapActions('messaging', ['requestAllMessages', 'markMessageAsRead', 'requestUnreadCount']),

    getHeading(messageType) {
      return messageType === 'received' ? 'Received Messages' : 'Sent Messages';
    },

    newMessage() {
      this.$router.push('/messages/contacts');
      localStorage.removeItem('contactID');
    },

    openMessage(message) {

      const receivedMessage = JSON.parse(localStorage.getItem('updateUser')).mdlive_id !== message.from_id;
      localStorage.setItem('messageID', message.id );

      if(receivedMessage) {
        localStorage.setItem('contactID', message.from_id);

        if(message.unread_status) {
          this.markMessageAsRead(message.id);
        }
      }
      else {
        localStorage.setItem('contactID', message.to_id);
      }

      this.$router.push('/messages/view');
    },

    getPaginated(direction) {
      this.messagesPayload.direction = direction;
      this.requestAllMessages(this.messagesPayload);
      window.scrollTo(0,0);
    },

  },

  created() {
    this.requestAllMessages(this.messagesPayload);
  },

};
</script>



// WEBPACK FOOTER //
// Inbox.vue?86d95b5a